import { useCallback, useEffect } from "react";
import { useAppContext, useService } from "../../../../hooks";

export const useFeaturedServices = () => {
  const {
    actions: { setServices },
    selectors: { getServices },
  } = useAppContext();
  const { getServices: fetchServices } = useService("Service");

  const getServicesData = useCallback(async () => {
    const result = await fetchServices();
    if (result.status) {
      if (result.data?.length !== 0) {
        setServices(result.data);
      }
    }
  }, [fetchServices, setServices]);

  const compare = useCallback((a, b, key: string = "publishDate") => {
    if (new Date(a[key]) < new Date(b[key])) return -1;
    if (new Date(a[key]) > new Date(b[key])) return 1;
    return 0;
  }, []);

  useEffect(() => {
    if (getServices().length === 0) {
      getServicesData();
    }
  }, [getServices, getServicesData]);

  return {
    serviceList: getServices()
      .sort(compare)
      .filter(
        (item) => item.status === "publish" && item.isFeatured === "true"
      ),
  };
};
